import {
	SELECT_CU_PROD_SMELTER,
	UNSELECT_CU_PROD_SMELTER,
	RESET_CU_PROD_SMELTERS
} from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case SELECT_CU_PROD_SMELTER:
			return [...state, action.payload];
		case UNSELECT_CU_PROD_SMELTER:
			return state.filter((item) => item !== action.payload);
		case RESET_CU_PROD_SMELTERS:
			return [];

		default:
			return state;
	}
};
